import React, { useState } from "react";
import { api } from "@/lib/api";
import { Search, CheckCircle2, XCircle } from "lucide-react";
import { fmtDate } from "@/lib/api";

export default function CheckCertificate() {
  const [q, setQ] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    setLoading(true); setError(null); setResult(null);
    try {
      const r = await api.get(`/certificates/verify/${encodeURIComponent(q.trim())}`);
      setResult(r.data);
    } catch (err) {
      setError(err.response?.data?.detail || "Sertifikat tidak ditemukan.");
    }
    setLoading(false);
  };
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700 mb-3">Verifikasi</div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-emerald-950">Cek Sertifikat</h1>
      <p className="mt-4 text-slate-600">Masukkan nomor sertifikat untuk memverifikasi keabsahan sertifikat kompetensi.</p>
      <form onSubmit={submit} className="mt-8 flex gap-3">
        <input data-testid="cert-input" value={q} onChange={e => setQ(e.target.value)} placeholder="Contoh: LSP-REI-2026-0001"
          className="flex-1 px-5 py-4 rounded-xl border-2 border-slate-200 focus:border-emerald-700 outline-none font-mono text-sm" />
        <button data-testid="cert-check-btn" disabled={loading} className="inline-flex items-center gap-2 px-6 py-4 rounded-xl bg-emerald-950 text-white font-bold hover:bg-emerald-800 transition-colors">
          <Search className="w-4 h-4" /> {loading ? "Memeriksa..." : "Cek"}
        </button>
      </form>
      {error && (
        <div data-testid="cert-not-found" className="mt-8 rounded-2xl border-2 border-red-200 bg-red-50 p-6 flex gap-3">
          <XCircle className="w-6 h-6 text-red-600 shrink-0" />
          <div><div className="font-bold text-red-800">Tidak Ditemukan</div><div className="text-sm text-red-700 mt-1">{error}</div></div>
        </div>
      )}
      {result && (
        <div data-testid="cert-result" className="mt-8 rounded-2xl border-2 border-emerald-200 bg-emerald-50 p-8">
          <div className="flex items-center gap-3 mb-6"><CheckCircle2 className="w-8 h-8 text-emerald-600" /><div className="font-display text-xl font-extrabold text-emerald-900">Sertifikat Valid</div></div>
          <dl className="grid sm:grid-cols-2 gap-4 text-sm">
            <div><dt className="text-slate-500 text-xs uppercase tracking-widest font-bold">Nomor Sertifikat</dt><dd className="font-mono text-emerald-950 mt-1">{result.certificate_number}</dd></div>
            <div><dt className="text-slate-500 text-xs uppercase tracking-widest font-bold">Nama Pemegang</dt><dd className="text-emerald-950 mt-1 font-semibold">{result.holder_name}</dd></div>
            <div className="sm:col-span-2"><dt className="text-slate-500 text-xs uppercase tracking-widest font-bold">Skema Sertifikasi</dt><dd className="text-emerald-950 mt-1">{result.scheme_title}</dd></div>
            <div><dt className="text-slate-500 text-xs uppercase tracking-widest font-bold">Status</dt><dd className="text-emerald-700 mt-1 font-bold">{result.status}</dd></div>
            <div><dt className="text-slate-500 text-xs uppercase tracking-widest font-bold">Tanggal Terbit</dt><dd className="text-emerald-950 mt-1">{fmtDate(result.issue_date)}</dd></div>
            {result.valid_until && <div><dt className="text-slate-500 text-xs uppercase tracking-widest font-bold">Masa Berlaku</dt><dd className="text-emerald-950 mt-1">{fmtDate(result.valid_until)}</dd></div>}
          </dl>
        </div>
      )}
    </div>
  );
}
